import React, { Fragment, useContext } from "react"

import { Slide } from "../../display_wallet.js"
import Slide_History_Tokens from "./Slide_History_Tokens.js"
import Slide_History_BSV from "./Slide_History_BSV.js"
import { UserContext } from "../../Contexts/UserContext/UserContext.js"
import { getLog } from "../../helpers/helpers.js"
import CoinHeader from "../../components/CoinHeader.js"


export default function Slide_History(props) {
	const userContext = useContext(UserContext)
	const function_id = "Slide_History: "
	const log = getLog(function_id)

	const coinProps = userContext.get_selected_coin_props()
	// examples: coinProps.tokenid ticker .name .logo .color
	log("coinProps.tokenid=", coinProps.tokenid)

	let slide_jsx = null
	if (coinProps.tokenid === 'bsv') {
		slide_jsx = <Slide_History_BSV {...props} />
	}
	else {
		slide_jsx = <Slide_History_Tokens {...props} />
	}

	return (
		<Slide num={props.num} >
			<center>
				<CoinHeader />
				<br />
				{slide_jsx}
			</center>
		</Slide>
	)

	/* // old version
	return (
		<Slide num={props.num} dontaddspacebelow style={{ paddingTop: "0px", overflowX: "hidden" }}>
			<With2Tabs
				startingtab="1"
				title_tab1="Historique Delphe"
				title_tab2="Historique BSV"
				content_tab1={jsx_slide_history_tokens}
				content_tab2={jsx_slide_history_bsv}
			/>
		</Slide>
	)
	 */
}
